import "@fontsource/cormorant-garamond/300.css";
import "@fontsource/cormorant-garamond/400.css";
import "@fontsource/cormorant-garamond/500.css";
import "@fontsource/outfit/300.css";
import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/manrope/300.css";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";

import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { PetProfileProvider } from "@/context/PetProfileContext";
import { HyperColorProvider } from "@/context/HyperColorContext";
import EmpireTotal from "@/components/EmpireTotal";
import CartFlourish from "@/components/CartFlourish";
import MusicBar from "@/components/MusicBar";
import { MusicProvider } from "@/context/MusicContext";
import HyperColorControl from "@/components/HyperColorControl";
import SplashScreen from "@/components/SplashScreen";
import Navbar from "@/components/Navbar";
import MissionWhisper from "@/components/MissionWhisper";
import PreorderBanner from "@/components/PreorderBanner";
import Footer from "@/components/Footer";
import Concierge from "@/components/Concierge";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Bandanas from "@/pages/Bandanas";
import MissionDrop from "@/pages/MissionDrop";
import Sets from "@/pages/Sets";
import ProductDetail from "@/pages/ProductDetail";
import Collabs from "@/pages/Collabs";
import DogGear from "@/pages/DogGear";
import BuildAFit from "@/pages/BuildAFit";
import Wrap from "@/pages/Wrap";
import Hub from "@/pages/Hub";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Account from "@/pages/Account";
import Auth from "@/pages/Auth";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Rescue from "@/pages/Rescue";
import Collab from "@/pages/Collab";
import TryOn from "@/pages/TryOn";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Donate from "@/pages/Donate";
import Sponsor from "@/pages/Sponsor";
import Ranch from "@/pages/Ranch";
import SaveTheChildren from "@/pages/SaveTheChildren";
import FosterPortal from "@/pages/FosterPortal";
import ArtWorkz from "@/pages/ArtWorkz";
import HouseOfWigglez from "@/pages/HouseOfWigglez";
import PreOrders from "@/pages/PreOrders";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground font-body">
      <BrowserRouter>
        <AuthProvider>
          <MusicProvider>
          <CartProvider>
            <PetProfileProvider>
            <HyperColorProvider>
            <SplashScreen />
            <MissionWhisper />
            <PreorderBanner />
            <Navbar />
            <main className="min-h-[70vh]">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/mission" element={<MissionDrop />} />
                <Route path="/sets" element={<Sets />} />
                <Route path="/bandanas" element={<Bandanas />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/collabs" element={<Collabs />} />
                <Route path="/dog-gear" element={<DogGear />} />
                <Route path="/build" element={<BuildAFit />} />
                <Route path="/rescue" element={<Rescue />} />
                <Route path="/collab" element={<Collab />} />
                <Route path="/try-on" element={<TryOn />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/wrap" element={<Wrap />} />
                <Route path="/hub" element={<ProtectedRoute><Hub /></ProtectedRoute>} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
                <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/login" element={<Navigate to="/auth" replace />} />
                <Route path="/signin" element={<Navigate to="/auth" replace />} />
                <Route path="/register" element={<Navigate to="/auth" replace />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/donate" element={<Donate />} />
                <Route path="/sponsor" element={<Sponsor />} />
                <Route path="/ranch" element={<Ranch />} />
                <Route path="/save-the-children" element={<SaveTheChildren />} />
                <Route path="/foster" element={<FosterPortal />} />
                <Route path="/artworkz" element={<ArtWorkz />} />
                <Route path="/signature" element={<HouseOfWigglez />} />
                <Route path="/pre-order" element={<PreOrders />} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
            <Concierge />
            <EmpireTotal />
            <CartFlourish />
            <MusicBar />
            <HyperColorControl />
            <Toaster theme="dark" position="top-right" richColors />
            </HyperColorProvider>
            </PetProfileProvider>
          </CartProvider>
          </MusicProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
